import { Link } from "react-router-dom";
import Tags from "../utils/Tags";

export default function SingleBlog({ blog }) {
  const { id, title, image, createdAt, tags, isSaved, likes } = blog;

  return (
    <div className="lws-card">
      <Link to={`/blogs/${id}`}>
        <img
          src={image}
          className="lws-card-image"
          alt="git"
        />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up" />
            {likes}
          </p>
        </div>
        <Link
          to={`/blogs/${id}`}
          className="lws-postTitle"
        >
          {title}
        </Link>
        <Tags
          className="lws-tags"
          tags={tags}
        />

        {isSaved && (
          <div className="flex gap-2 mt-4">
            <span className="lws-badge"> Saved </span>
          </div>
        )}
      </div>
    </div>
  );
}
